import { SMALL_MEDIA_QUERY } from "~/report/const";
import { reportWaitForLogin, reportAnalytics } from "~/report/util";
import Report from "~/report/index";
import { getAddPlaceOptions, getReportDefectOptions, getMapErrorOptions, getMapErrorOnUpdate, getMapNoteOptions, getPremiumProblem } from "~/report/options";
import { _ } from "~/i18n";
import Scene from "~/scene";
import Notifications, { NOTIFICATIONS_TYPE } from "~/util/notifications";
import { store } from "~/state/store";

export type TFeedbackType = "addplace" | "maperror" | "error" | "note";

function feedbackResponsiveTest() {
	return !window.matchMedia(SMALL_MEDIA_QUERY).matches;
}

export function showFeedbackError() {
	Mapy.getComponent("layout").setState({
		l: 1,
	});
	Notifications.notify({
		content: _("report.responsiveError"),
		type: NOTIFICATIONS_TYPE.ERROR,
	});
	Mapy.getComponent("history").save(true);
}

export async function onAddPlace(replaceUrl?: boolean) {
	if (replaceUrl && !feedbackResponsiveTest()) {
		showFeedbackError();

		return;
	}

	reportAnalytics({
		origin: replaceUrl ? "feedback_link" : "settings",
		text: "Přidat chybějící místo",
		type: "missingPlace",
	});

	await reportWaitForLogin();

	const curState = store.getState();
	const report = new Report(getAddPlaceOptions({
		values: {},
		analytics: {
			type: "missingPlace",
			origin: "settings",
		},
		coords: {
			lon: curState.map.longitude,
			lat: curState.map.latitude,
		},
	}));

	report.open();
	replaceUrl && Mapy.getComponent("history").save(true);
}

export async function onMapError(replaceUrl?: boolean) {
	if (replaceUrl && !feedbackResponsiveTest()) {
		showFeedbackError();

		return;
	}

	reportAnalytics({
		origin: replaceUrl ? "feedback_link" : "settings",
		text: "Chyba v mapě",
		type: "mistake",
	});

	if (!Scene.isMapActive()) {
		try {
			await Scene.setActive("map");
		} catch (ex) {
			//
		}
	}

	await reportWaitForLogin();

	const report = new Report(getMapErrorOptions("settings"));

	report.setOnUpdate(getMapErrorOnUpdate);
	report.open();
	replaceUrl && Mapy.getComponent("history").save(true);
}

export async function onSomethingWrong(replaceUrl?: boolean) {
	if (replaceUrl && !feedbackResponsiveTest()) {
		showFeedbackError();

		return;
	}

	reportAnalytics({
		origin: replaceUrl ? "feedback_link" : "settings",
		text: "Něco nefunguje",
		type: "broken",
	});

	await reportWaitForLogin();

	const report = new Report(getReportDefectOptions("", "settings"));

	report.open();
	replaceUrl && Mapy.getComponent("history").save(true);
}

export async function onMapNote(replaceUrl?: boolean) {
	if (replaceUrl && !feedbackResponsiveTest()) {
		showFeedbackError();

		return;
	}

	reportAnalytics({
		origin: replaceUrl ? "feedback_link" : "settings",
		text: "Připomínka k Mapy.cz",
		type: "notice",
	});

	await reportWaitForLogin();

	const report = new Report(getMapNoteOptions());

	report.open();
	replaceUrl && Mapy.getComponent("history").save(true);
}

export async function onAddBusiness(isCzechia = false) {
	reportAnalytics({
		origin: "settings",
		text: "Přidat svou firmu",
		type: isCzechia ? "goToFirmy" : "addOsmFirm",
	});

	if (!isCzechia) {
		await reportWaitForLogin();

		const curState = store.getState();
		const report = new Report(getAddPlaceOptions({
			values: {},
			analytics: {
				type: isCzechia ? "missingPlace" : "addOsmFirm",
				origin: "settings",
			},
			coords: {
				lon: curState.map.longitude,
				lat: curState.map.latitude,
			},
		}));

		report.open();
	}
}

export async function onPremium() {
	reportAnalytics({
		origin: "settings",
		text: "Problém s Mapy.cz Premium",
		type: "premium",
	});

	await reportWaitForLogin();

	const report = new Report(getPremiumProblem("", "settings"));

	report.open();
}
